import type { AppDispatch } from '../store';
import { subscriptionApi } from '../slices/subscriptionSlice';

// WE-492: the shared primitive behind every "token balance changed outside
// subscriptionApi's own mutations" site. Call it after a flow that grants
// tokens (onboarding bonus); for flows that *spend* tokens use chargeTokens()
// instead — it wraps this and additionally emits the `charge_tokens`
// analytics event.
export function refreshSubscriptionUsage(dispatch: AppDispatch): void {
    dispatch(subscriptionApi.util.invalidateTags(['SubscriptionUsage']));
}
